import { styled } from '@linaria/react';
import theme from '@clad-ui/theme';
const {
  radii
} = theme;
const typeIconClass = "tv4xrbp";
/* limit description to 2 lines */
const lineLimitClass = "l1upzfzs";
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "c1en0hm0",
  propsAsIs: false
});
const StyledAnnouncer = /*#__PURE__*/styled('div')({
  name: "StyledAnnouncer",
  class: "smxv28x",
  propsAsIs: false
});
const ExpandButton = /*#__PURE__*/styled('button')({
  name: "ExpandButton",
  class: "e1384jt3",
  propsAsIs: false
});
const ActionButton = /*#__PURE__*/styled('button')({
  name: "ActionButton",
  class: "aqjynm9",
  propsAsIs: false
});
const CloseButton = /*#__PURE__*/styled('button')({
  name: "CloseButton",
  class: "c98fz5",
  propsAsIs: false
});
const _exp60 = /*#__PURE__*/() => ({
  width
}) => width;
const _exp61 = /*#__PURE__*/() => ({
  height
}) => height;
const _exp62 = /*#__PURE__*/() => ({
  radius
}) => radius || radii.sm;
const _exp64 = /*#__PURE__*/() => ({
  margin
}) => margin || 0;
const Skeleton = /*#__PURE__*/styled('div')({
  name: "Skeleton",
  class: "sr2ujw2",
  propsAsIs: false,
  vars: {
    "sr2ujw2-0": [_exp60()],
    "sr2ujw2-1": [_exp61()],
    "sr2ujw2-2": [_exp62()],
    "sr2ujw2-3": [_exp64()]
  }
});
const SkeletonWrapper = /*#__PURE__*/styled('div')({
  name: "SkeletonWrapper",
  class: "s17twsy9",
  propsAsIs: false
});
export { typeIconClass, StyledAnnouncer, lineLimitClass, ExpandButton, ActionButton, CloseButton, ChildrenWrapper, Skeleton, SkeletonWrapper };

require("./Announcer.styles.linaria.module.css");